import LockIcon from '@material-ui/icons/Lock';
import { Button } from '@material-ui/core';
import _ from 'lodash';
import * as React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AgreementsForm from '../components/Forms/AgreementsForm';
import { AgreementsActions, fetchLatestAgreements } from '../redux/agreements/agreements.actions';
import * as SettingsActions from '../redux/settings/settings.actions';
import { IState } from '../redux/store';
import { AGREEMENT_TYPES, LANGUAGES } from '../utils/AgreementConstants';
import translations from '../translations/i18next';
import logo from '../assets/logos/logoVashoIconDark.png';

type IReduxProps = ConnectedProps<typeof connector>;

export interface IPrivacyPolicyViewProps extends RouteComponentProps<any> {}

export type ComponentProps = IPrivacyPolicyViewProps & IReduxProps;

class PrivacyPolicyView extends React.Component<ComponentProps> {
  private agreementsFormInstance: any = null;
  private isFormValid: boolean = false;

  async componentDidMount() {
    const { dispatch } = this.props;
    dispatch<any>(SettingsActions.setSpinnerVisible(true));
    try {
      await dispatch<any>(fetchLatestAgreements({ type: AGREEMENT_TYPES.PRIVACY }));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      this.props.history.push('/login');
    }
  }

  onAcceptPrivacyPolicies = () => {
    if (this.agreementsFormInstance && this.agreementsFormInstance.handleSubmit) {
      this.agreementsFormInstance.handleSubmit();
    }
  }

  onFormReady = (form: any) => {
    this.agreementsFormInstance = form;
  }

  onValidityChange = (isValid: boolean) => {
    this.isFormValid = isValid;
    this.forceUpdate();
  }

  onAcceptPrivacyPoliciesConfirm = (values: { [key: string]: boolean }) => {
    const { dispatch, acceptedAgreements } = this.props;
    let formattedAgreements: any[] = [];
    _.each(_.keys(values), (k) => {
      if (values[k]) {
        formattedAgreements = [...formattedAgreements, k];
      }
    });
    dispatch(AgreementsActions.saveAcceptedAgreements([...formattedAgreements, ...acceptedAgreements]));
    dispatch(AgreementsActions.saveAgreements([]));
    this.props.history.push('/termsAndConditions');
  }

  render() {
    const { agreements, language } = this.props;
    const languageSuffix = language && language === LANGUAGES.ITALIAN ? 'it' : 'en';
    const t = translations.getFixedT(language || 'en');
    
    return (
      <div style={{ overflow: 'scroll', display: 'flex', flexDirection: 'column', backgroundColor: 'white', height: '100vh', padding: 10 }}>
        <img src={logo} alt="logo" style={{ margin: 'auto', marginTop: 60, marginBottom: 15, alignSelf: 'center', height: 60 }} />
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <LockIcon style={{ color: '#3f3f3f' }} />
          <h3 style={{ color: '#3f3f3f', textAlign: 'center', margin: 0, marginLeft: 10, fontWeight: 'bold' }}>
            {t('agreements.privacyPolicy')}
          </h3>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          {agreements && agreements.data ?
            <div>
              {agreements.data.length ?
                <iframe scrolling="yes" style={{ borderColor: '#1EBE9C' }} src={`${agreements.data[0].link}/${languageSuffix}`} width="800" height="450" />
              : null}
              <AgreementsForm
                {...({
                  agreements: agreements.data,
                  onSubmit: this.onAcceptPrivacyPoliciesConfirm,
                  onFormReady: this.onFormReady,
                  onValidityChange: this.onValidityChange,
                } as any)}
              />
            </div>
          : null}
        </div>
        <Button
          variant="contained"
          disabled={!this.isFormValid}
          style={{ backgroundColor: this.isFormValid ? '#1EBE9C' : '#cccccc', color: 'white', marginTop: 20, alignSelf: 'center', padding: '10px 40px', fontWeight: 'bold' }}
          onClick={this.onAcceptPrivacyPolicies}
        >
          {t('agreements.acceptAgreements')}
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    agreements: state.agreements,
    acceptedAgreements: state.agreements.acceptedAgreements,
  };
}

const connector = connect(mapStateToProps);
export default connector(withRouter(PrivacyPolicyView));
